import React, { useEffect, useState } from "react";
import Layout from "../layouts/index.jsx";
import Header from "../layouts/header";
import Breadcrumb from "../containers/global/breadcrumb";
import Footer from "../layouts/footer";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import SeoData from "../data/seo.json";
import ColumnData from "../data/column.json";

const BLOG_URL = "https://blog.naver.com/gwamsa0916";

const ColumnPage = () => {
    // 기본은 저장된 목록, 배포 환경에서는 하루 한 번 갱신되는 /api/posts 로 대체
    const [posts, setPosts] = useState(ColumnData);
    useEffect(() => {
        fetch("/api/posts")
            .then((res) => (res.ok ? res.json() : Promise.reject()))
            .then((data) => {
                if (Array.isArray(data.posts) && data.posts.length > 0) {
                    setPosts(data.posts);
                }
            })
            .catch(() => {});
    }, []);
    return (
        <React.Fragment>
            <Layout>
                <SEO {...SeoData["/column"]} pathname="/column" />
                <div className="wrapper">
                    <Header />
                    <div className="main-content site-wrapper-reveal">
                        <Breadcrumb
                            classOptionOne="content-style3"
                            classOptionTwo="bread-crumbs-style2"
                            prevs={[{ text: "홈", path: "/" }]}
                            contentThree="닥터칼럼"
                            title="<span>정환교 피부과</span> 닥터칼럼"
                        />
                        <div className="blog-area section-py blog-border-bottom">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-10 mx-auto">
                                        <div className="post-items-style2">
                                            {posts.map((post) => (
                                                <div className="post-item" key={post.url}>
                                                    <div className="content">
                                                        <h4 className="title">
                                                            <a href={post.url} target="_blank" rel="noopener noreferrer">
                                                                {post.title}
                                                            </a>
                                                        </h4>
                                                        <div className="meta">
                                                            <span>{post.date}</span>
                                                            <a href={post.url} target="_blank" rel="noopener noreferrer">
                                                                네이버 블로그에서 읽기 <i className="icofont-external-link"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="text-center mt-5">
                                            <a
                                                className="btn btn-theme"
                                                href={BLOG_URL}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                블로그 전체 글 보기 <i className="icofont-external-link"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default ColumnPage;
